import ColisScanner from "@/components/colis/ColisScanner";
import DeliveryConfirmationDialog from "@/components/dialogs/DeliveryConfirmationDialog";
import ActionButton from "@/components/loader-button/ActionButton";
import { NavigationRoutes } from "@/components/navigation/constants";
import ReturnHeader from "@/components/return/ReturnHeader";
import { Toaster } from "@/components/ui/toaster";
import { Roles } from "@/enums";
import { DialogType } from "@/enums/dialogs";
import { toast } from "@/hooks/use-toast";
import { Colis, ReturnToCreate } from "@/interfaces/Return";
import { confirmerReceptionHUB } from "@/services/hub-reception-confirmation.service";
import { confirmerReceptionVendeur } from "@/services/return-reception-confirmation.service";
import { closeDialog, openDialog } from "@/store/reducers/dialogReducer";
import { RootState } from "@/store/store";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ReturnDeliveryValidationPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [scannedColis, setScannedColis] = React.useState<Colis[]>([]);
  const [isLoading, setIsloading] = React.useState(false);
  const return_ = useSelector((state: RootState) => state.return.return);
  const isOpen = useSelector((state: RootState) => state.dialog.isOpen);
  const roles = useSelector((state: RootState) => state.authentication.roles);

  const validationButtonDisabled = () => {
    return scannedColis.length !== return_.colis?.length;
  };

  const handleValidation = async () => {
    if (isOpen === false) {
      dispatch(openDialog(DialogType.DELIVERY_CONFIRMATION_DIALOG));
      return;
    }
    const request = {
      numTournee: return_.numTournee.toString() || "",
      isSellerVIP: return_.isSellerVIP,
      sellerId: return_.sellerId,
      entityId: return_.entityId,
    } as ReturnToCreate;
    dispatch(closeDialog());
    setIsloading(true);
    if (roles.includes(Roles.HUB_ROLE)) {
      const response = await confirmerReceptionHUB(request);
      if (response.status === 200 && response.data.success === true) {
        toast({
          title: "Réception validée",
          variant: "success",
        });
        navigate(NavigationRoutes.DASHBOARD, { replace: true });
      } else {
        toast({
          title: "Erreur lors de la validation",
          variant: "destructive",
        });
      }
    } else {
      const response = await confirmerReceptionVendeur(request);
      if (response.status === 200 && response.data.success === true) {
        toast({
          title: "Réception validée",
          variant: "success",
        });
        navigate(NavigationRoutes.DASHBOARD, { replace: true });
      } else {
        toast({
          title: "Erreur lors de la validation",
          variant: "destructive",
        });
      }
      setIsloading(false);
    }
  };

  return (
    <div className="flex flex-col h-full gap-4">
      <ReturnHeader return_={return_} />
      <ColisScanner
        scannedColis={scannedColis}
        setScannedColis={setScannedColis}
        colis={return_.colis}
      />
      <div className="px-4 flex space-x-4 flex-row">
        <ActionButton
          loading={isLoading}
          disabled={validationButtonDisabled() || isLoading}
          handleClick={handleValidation}
          label="Valider le réception"
        />
      </div>
      <Toaster />
      <DeliveryConfirmationDialog handleValidate_={handleValidation} />
    </div>
  );
};

export default ReturnDeliveryValidationPage;
